export const USER_VERIFY_TOKEN = 'USER_VERIFY_TOKEN';
export const USER_VERIFY_TOKEN_SUCCESS = 'USER_VERIFY_TOKEN_SUCCESS';
export const USER_VERIFY_TOKEN_ERROR = 'USER_VERIFY_TOKEN_ERROR';

export const verifyUserToken = data => ({
  type: USER_VERIFY_TOKEN,
  payload: data,
});
